import { testimonials } from "@/mocks/testimonials";
import SectionHeading from "./SectionHeading";

const principles = [
  {
    icon: "ri-time-line",
    title: "只按脉络写，不按情绪写",
    desc: "每个事件都先厘清时间顺序，再讨论争议点。我们尽量把「发生了什么」和「大家怎么看」分开陈述。",
  },
  {
    icon: "ri-link-m",
    title: "标注来源与节点",
    desc: "关键节点会标注日期，未证实的传闻明确写「待确认」，不让读者把猜测当成结论。",
  },
  {
    icon: "ri-refresh-line",
    title: "有进展就补上",
    desc: "事件出现新回应时，我们会回填到原有时间线，而不是另开一篇重复的内容。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20">
      <div className="w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center mb-14">
          <div>
            <SectionHeading
              eyebrow="关于我们"
              title="5.1吃瓜，一个帮你梳理脉络的吃瓜站"
              desc="我们不做碎片化的消息搬运，而是把同一件事的零散信息重新组织起来，让读者花几分钟就能掌握完整背景。"
            />
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              站点由一群长期关注娱乐行业的编辑与读者共同维护。我们相信，吃瓜本身没什么问题，问题在于信息太碎、时间线太乱，导致很多人只看得到最激烈的那一段，却不知道前面发生过什么。5.1吃瓜想改变的，正是这一点。
            </p>
            <div className="flex flex-wrap gap-6">
              <div>
                <p className="font-heading font-bold text-2xl md:text-3xl text-primary-600">171+</p>
                <p className="text-xs text-foreground-600 mt-1">累计盘点事件</p>
              </div>
              <div>
                <p className="font-heading font-bold text-2xl md:text-3xl text-primary-600">6 大类</p>
                <p className="text-xs text-foreground-600 mt-1">内容方向覆盖</p>
              </div>
              <div>
                <p className="font-heading font-bold text-2xl md:text-3xl text-primary-600">每日</p>
                <p className="text-xs text-foreground-600 mt-1">热度榜更新频率</p>
              </div>
            </div>
          </div>

          <div className="w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20editorial%20desk%20scene%20with%20notebook%20camera%20and%20amber%20light%2C%20organized%20timeline%20notes%20on%20cream%20paper%2C%20soft%20natural%20shadows%2C%20top%20down%20magazine%20style%2C%20no%20text&width=1100&height=800&seq=gua-about-01&orientation=landscape"
              alt="5.1吃瓜 编辑台与事件时间线整理场景"
              title="5.1吃瓜 内容整理流程"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-14">
          {principles.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl mb-4">
                <i className={item.icon} />
              </span>
              <h3 className="font-heading font-bold text-foreground-950 text-base md:text-lg mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <h3 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl mb-6 text-center">
          读者怎么说
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500 mb-3" />
              <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1 mb-5">
                {item.quote}
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-4 border-t border-background-100">
                <span className="w-11 h-11 rounded-full overflow-hidden shrink-0">
                  <img
                    src={item.avatar}
                    alt={`${item.name} 头像`}
                    title={`${item.name} - 5.1吃瓜读者`}
                    className="w-full h-full object-cover object-top"
                  />
                </span>
                <span>
                  <span className="block font-medium text-foreground-950 text-sm">{item.name}</span>
                  <span className="block text-xs text-foreground-500 mt-0.5">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}